/**
 * Variant-Based Recently Viewed Tracker
 * Tracks which variants (not just products) customer has viewed
 * Storage: localStorage with key 'Concept:recently-viewed'
 * Format: Simple array of variant IDs [40123, 40124, ...]
 * Limit: Last 10 viewed variants
 */

(function() {
  const STORAGE_KEY = 'Concept:recently-viewed';
  const MAX_ITEMS = 10;

  class VariantTracker {
    constructor() {
      this.init();
    }

    init() {
      // Track on product page when variant changes
      if (window.location.pathname.includes('/products/')) {
        this.trackProductPage();
      }
    }

    trackProductPage() {
      // Wait for page to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.trackCurrentVariant());
      } else {
        this.trackCurrentVariant();
      }

      // Listen for variant changes (when user selects different variant)
      document.addEventListener('variant:changed', (e) => {
        if (e.detail && e.detail.variant && e.detail.variant.id) {
          this.trackVariant(e.detail.variant.id);
        }
      });
    }

    trackCurrentVariant() {
      // Get current variant ID from page
      const variantId = this.getCurrentVariantId();
      if (variantId) {
        this.trackVariant(variantId);
      }
    }

    getCurrentVariantId() {
      // Try multiple methods to get variant ID
      
      // Method 1: From product form
      const form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        const input = form.querySelector('[name="id"]');
        if (input && input.value) {
          return parseInt(input.value);
        }
      }

      // Method 2: From select element
      const select = document.querySelector('select[name="id"]');
      if (select && select.value) {
        return parseInt(select.value);
      }

      // Method 3: From hidden input
      const hiddenInput = document.querySelector('input[name="id"][type="hidden"]');
      if (hiddenInput && hiddenInput.value) {
        return parseInt(hiddenInput.value);
      }

      // Method 4: From data attribute on product
      const productElement = document.querySelector('[data-product-id]');
      if (productElement && productElement.dataset.variantId) {
        return parseInt(productElement.dataset.variantId);
      }

      // Method 5: Try to find in window.ShopifyAnalytics
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        const variant = window.ShopifyAnalytics.meta.product.variants[0];
        if (variant && variant.id) {
          return variant.id;
        }
      }

      return null;
    }

    trackVariant(variantId) {
      if (!variantId) return;

      const viewed = this.getViewed();
      
      // Remove if already exists (to move to front)
      const filtered = viewed.filter(id => id !== variantId);
      
      // Add to front
      filtered.unshift(variantId);
      
      // Keep only last MAX_ITEMS
      const limited = filtered.slice(0, MAX_ITEMS);
      
      // Save
      this.saveViewed(limited);
    }

    getViewed() {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) return [];
        
        const parsed = JSON.parse(stored);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.error('Error reading recently viewed:', e);
        return [];
      }
    }

    saveViewed(viewed) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
      } catch (e) {
        console.error('Error saving recently viewed:', e);
      }
    }
  }

  // Initialize tracker
  new VariantTracker();
})();
